import React from 'react';
import Jumbotron  from '../../components/jumbotron/Jumbotron';
import img1 from "../../assets/images/pharmacy/diabetic-care.jpg"
import img2 from "../../assets/images/pharmacy/bath-safety.jpg"
import img3 from "../../assets/images/pharmacy/skin-care.jpg"
import img4 from "../../assets/images/pharmacy/ostomy.png"
import img5 from "../../assets/images/pharmacy/compression-stockings.jpg"
import img6 from "../../assets/images/pharmacy/incontinence.jpg"
import img7 from "../../assets/images/pharmacy/wound-care-supply.jpg"
import img8 from "../../assets/images/pharmacy/pain-therapy--supports.png"
import img9 from "../../assets/images/pharmacy/pediatric-supply.jpg"
import img10 from "../../assets/images/pharmacy/walking-accessories-1.jpg"
import img11 from "../../assets/images/pharmacy/daily-living-aids.jpg"

const jumboData = [
    {
      "id": 1,
      "title": "YOUR RIGHT PARTNER FOR DIABETIC CARE",
      "subTitle": "Diabetes is a common disease, yet everyone has unique needs. We offer a full line of products to meet your diabetic needs.",
      "image": img1,
      "alt": "Diabetes",
      "direction": "row"
    },
    {
      "id": 2,
      "title": "PREVENTION IS BETTER THAN CARE",
      "subTitle": "A Damaging slip and fall can have serious effect on the quality of life of a person of any age. One bad accident around the house is enough to severely hinder independence and mobility.",
      "image": img2,
      "alt": "Bath Safety",
      "direction": "row-reverse"
    },
    {
      "id": 3,
      "title": "MAKING YOUR SKIN AND FEET HAPPY",
      "subTitle": "Proper skin care medication is important because our skin is the largest barrier against infection that we have. Keeping skin healthy and moist keeps this barrier strong and we strive to provide the products producing the best results.",
      "image": img3,
      "alt": "Skin Care",
      "direction": "row"
    },
    {
      "id": 4,
      "title": "MAKING OSTOMY CARE EASIER",
      "subTitle": "The most crucial step to living life well with an ostomy is finding the product that is right for YOU. Each person's body and stoma are unique. We have a passion for ostomy here at Florida Pharmacy with a truly compassionate approach.",
      "image": img4,
      "alt": "Ostomy",
      "direction": "row-reverse"
    },
    {
      "id": 5,
      "title": "STOCKINGS TO IMPROVE CIRCULATION",
      "subTitle": "Compression stockings provide external support to the vein walls and work in conjunction with the calf muscle pump. They help minimize and control swelling and leg pain. There are 4 main compression levels which are measured in millimeters of mercury (mmHg). The higher the numbers, the higher the compression. Unless otherwise instructed by a medical professional, stockings should be worn during the day, while you are active.",
      "image": img5,
      "alt": "Compression Stockings",
      "direction": "row"
    },
    {
      "id": 6,
      "title": "TAKE CONTROL OF YOUR INCONTINENCE",
      "subTitle": "Incontinence and continence problems affect people of all ages, gender, cultures and backgrounds. Despite popular beliefs, older people are not the only ones affected.",
      "image": img6,
      "alt": "Incontinence",
      "direction": "row-reverse"
    },
    {
      "id": 7,
      "title": "YOUR WOUND HEALING AND CARE",
      "subTitle": "Florida Pharmacy offers an extensive selection of top-rated, best valued wound care supplies for surgical wound healing.",
      "image": img7,
      "alt": "Wound Care",
      "direction": "row"
    },
    {
      "id": 8,
      "title": "GET THE SUPPORT YOU NEED",
      "subTitle": "Orthopaedic disease, arthritis and trauma affect millions of people. Our varied product line can help make life a little easier using product lines like Swede-O, Futuro and Welso.",
      "image": img8,
      "alt": "Pain Therapy",
      "direction": "row-reverse"
    },
    {
      "id": 9,
      "title": "WE CARE FOR YOUR CHILD'S WELL BEING",
      "subTitle": "Making sure our little ones are cared for is one of the Florida Pharmacy's most important functions. We carry products that ensure your child can get the relief and comfort he or she needs",
      "image": img9,
      "alt": "PEDIATRIC",
      "direction": "row"
    },
    {
      "id": 10,
      "title": "WE KEEP YOU MOVING",
      "subTitle": "At Florida Pharmacy, we will make sure that each customer has the best walking accessories for his or her individual needs.",
      "image": img10,
      "alt": "WALKING ACCESSORIES",
      "direction": "row-reverse"
    },
    {
      "id": 11,
      "title": "DAILY LIVING AIDS FOR YOUR DAILY NEEDS",
      "subTitle": "One of the most important ways to stay independent is to have the proper tools needed to accomplishing daily living activities. These include being able to get dressed, get up and down from a chair, bed or toilet seat and be mobile. Here are some of the categories we have of daily living aids to significantly make it easier to do your day to day tasks.",
      "image": img11,
      "alt": "DAILY LIVING AIDS",
      "direction": "row"
    }
  ]
  

export function JumbotronContainer() {
  return (
    <Jumbotron.Container>
      {jumboData.map((item) => (
        <Jumbotron key={item.id} direction={item.direction}>
          <Jumbotron.Pane>
            <Jumbotron.Title>{item.title}</Jumbotron.Title>
            <Jumbotron.SubTitle>{item.subTitle}</Jumbotron.SubTitle>
          </Jumbotron.Pane>
          <Jumbotron.Pane>
            <Jumbotron.Image src={item.image} alt={item.alt} />
          </Jumbotron.Pane>
        </Jumbotron>
      ))}
    </Jumbotron.Container>
  );
}
